import { BaseGlobalSchema } from './baseGlobal.schema';
import z from 'zod';

const AlertBannersItemsSchema = z.object({
  id: z.string(),
  content: z.string(),
});

export const AlertBannersSchema = BaseGlobalSchema.extend({
  items: z.array(AlertBannersItemsSchema),
});
